












































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import BoxTile from '@/components/ui/BoxTile.vue';
import {SET_UNIT} from "@/store";
import AgeLabel from '@/components/ui/AgeLabel.vue';
import WeightLabel from '@/components/ui/WeightLabel.vue';
import PercentileLabel from '@/components/ui/PercentileLabel.vue';
import LengthLabel from '@/components/ui/LengthLabel.vue';
import WeightLenghtChart from '@/components/ui/growth-charts/WeightLenghtChart.vue';
import WeightAgeChart from '@/components/ui/growth-charts/WeightAgeChart.vue';
import LengthAgeChart from '@/components/ui/growth-charts/LengthAgeChart.vue';
import GlobalMixin from "@/mixins";

@Component({
  components: {
    LengthAgeChart,
    WeightAgeChart,
    WeightLenghtChart,
    LengthLabel,
    PercentileLabel,
    WeightLabel,
    AgeLabel,
    BoxTile
  },
})
export default class Growth extends GlobalMixin {

  get lastMeasurement() {
    if (this.$store.state.data && this.$store.state.data.weight_length && this.$store.state.data.weight_length.length)
      return this.$store.state.data.weight_length[this.$store.state.data.weight_length.length - 1];
    else return null;
  }

  get latestGoalDetails() {
    return this.$store.getters.goalDetailById('latest');
  }

  get latestGoal() {
    if (this.$store.state.data) {
      if (this.$store.state.data.goals && this.$store.state.data.goals.length) {
        return this.$store.state.data.goals[0].goalKey
      }
      return 'latest';
    }
    return 'latest';
  }

  get getSex() {
    if (this.$store.state.data && this.$store.state.data.base_info)
      return this.$store.state.data.base_info.sex
    else return '1';
  }

  get shouldDisplayBooklets() {
    const goal = this.latestGoalDetails;

    if (goal && goal.details &&
            goal.details.promptGoalBooklets &&
            goal.details.promptGoalBooklets.length) {
      return true;
    }
    return false;
  }

  get shouldDisplayHelp() {
    if (this.$store.state.data && this.$store.state.data.base_info && this.$store.state.data.base_info.help_contacts)
      return this.$store.state.data.base_info.help_contacts.length > 0
    else return false;
  }

  get entries() {
    if (this.$store.state.data && this.$store.state.data.weight_length && this.$store.state.data.weight_length.length)
      return this.$store.state.data.weight_length;
    else return [];
  }

  get entriesReversed() {
    return this.entries.map((x: any) => x).reverse();
  }

  get websiteId() {
    return this.$store.state.data ? this.$store.state.data.website_id : '';
  }

  private chartType: string = 'wl';

  public setUnit(unit: string) {
    this.$store.commit(SET_UNIT, unit);
  }

  public percentileWithExt(value: number) {
    switch (value % 10) {
      case 1: return value + 'st';
      case 2: return value + 'nd';
      case 3: return value + 'rd';
      default: return value + 'th';
    }
  }

  public onClickLearnMore(label: string) {
    this.track('Growth Links Click', label, this.websiteId);
  }

  private setChartType(type: string) {
    this.chartType = type;
    const mapping: { [key: string]: string } = {
      wl: 'Weight for Length',
      wa: 'Weight for Age',
      la: 'Length for Age'
    }
    this.track('Toggle Growth Chart', mapping[type] ? mapping[type] : '', this.websiteId);

  }



}
